import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  query, 
  where, 
  getDocs,
  updateDoc,
  deleteDoc,
  doc 
} from 'firebase/firestore';

export const createPayment = async (userId, paymentData) => {
  return await addDoc(collection(db, 'payments'), {
    userId,
    ...paymentData,
    createdAt: new Date()
  });
};

export const getPayments = async (userId) => {
  const q = query(collection(db, 'payments'), where('userId', '==', userId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const updatePayment = async (paymentId, data) => {
  const paymentRef = doc(db, 'payments', paymentId);
  return await updateDoc(paymentRef, data);
};

export const deletePayment = async (paymentId) => {
  return await deleteDoc(doc(db, 'payments', paymentId));
};
